export default "__VITE_ASSET__Dv0Doqyn__"